// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2ZlVC","modalFooterButton":"ModalNotes_modalFooterButton__effKo"};